<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <i class="icon-bell"></i>
      <b-badge v-if="totalUnread" pill variant="danger">{{
        totalUnread
      }}</b-badge>
    </template>
    <b-dropdown-header tag="div" class="text-center">
      <strong> You have {{ totalCount | pluralize("notification") }}</strong>
    </b-dropdown-header>
    <b-dropdown-item
      v-for="notification of computedNotifications"
      :key="notification.id"
      class="notification"
      @click="handleClick(notification)"
    >
      <div
        :class="{ 'text-muted': notification.read }"
        class="d-flex align-items-center"
      >
        <i class="dropdown-item-icon icon-user-follow text-success"></i>
        <div>
          <div :class="{ 'font-weight-bold': !notification.read }">
            {{ notification.title }}
          </div>
          <div class="small">{{ notification.message }}</div>
          <div v-if="notification.created_at" class="small text-muted">
            {{ timeAgo(notification) }}
          </div>
        </div>
        <div v-if="notification.id !== 'chat'" class="notification__extra">
          <div v-if="!notification.read" class="unread"></div>
          <div class="controls">
            <b-btn
              v-if="!notification.read"
              class="py-0 px-2"
              variant="link"
              @click.stop.prevent="readNotification(notification.id)"
            >
              <i class="icon-check text-primary" />
            </b-btn>
            <b-btn
              class="py-0 px-2"
              variant="link"
              @click.stop.prevent="deleteNotification(notification.id)"
            >
              <i class="icon-trash text-danger" />
            </b-btn>
          </div>
        </div>
      </div>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "header-dropdown-notif",

  computed: {
    ...mapGetters("chat", { chatUnread: "unread" }),
    ...mapGetters("notifications", ["count", "unread"]),
    ...mapState("notifications", ["notifications"]),

    computedNotifications() {
      const notifications = this.notifications.map(notification => ({
        ...notification,
        action: JSON.parse(notification.action)
      }));

      const n = this.chatUnread;
      if (n) {
        const s = n > 1 ? "s" : "";
        notifications.unshift({
          id: "chat",
          title: `Unread chat${s}`,
          message: `You have ${n} unread chat${s}`,
          action: { goto: "chat" }
        });
      }

      return notifications;
    },

    totalCount() {
      return this.count + (this.chatUnread ? 1 : 0);
    },

    totalUnread() {
      return this.unread + (this.chatUnread ? 1 : 0);
    }
  },

  created() {
    this.getNotifications();
    this.getChatUnread();
  },

  methods: {
    ...mapActions("chat", { getChatUnread: "getNumUnread" }),
    ...mapActions("notifications", [
      "deleteNotification",
      "getNotifications",
      "readNotification"
    ]),

    handleClick(notification) {
      if (notification.id !== "chat") this.readNotification(notification.id);
      const action = notification.action;
      if (action.goto && this.$route.path !== "/" + action.goto) {
        this.$router.push({ path: "/" + action.goto });
      }
    },

    timeAgo(notification) {
      return moment(notification.created_at).fromNow();
    }
  }
};
</script>

<style lang="scss">
.notification {
  &__extra {
    height: 100%;
    width: 1em;

    .controls {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      margin-right: 10px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 1em;

      i {
        margin: 0;
      }
    }

    .unread {
      margin-left: 10px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--primary);
    }
  }

  &:hover {
    .controls {
      display: flex;
    }
    .unread {
      display: none;
    }
  }

  .dropdown-item:active {
    color: unset;
    background-color: unset;
  }
}
</style>
